import React from "react";

const PlayButton: React.FC<{ className?: string; rectClassName?: string }> = ({
  className = "",
  rectClassName = "",
}) => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={["h-auto w-full", className].join(" ")}
  >
    <rect
      x="2"
      y="2"
      width="196"
      height="96"
      rx="6"
      className={[
        "fill-black/60 stroke-clhbid-orange stroke-[4] transition-colors hover:fill-black/80",
        rectClassName,
      ].join(" ")}
    />
    <path
      d="M90.5 70.6667C89.6667 71.2222 88.8194 71.25 87.9583 70.75C87.0972 70.25 86.6667 69.5 86.6667 68.5V31C86.6667 30 87.0972 29.25 87.9583 28.75C88.8194 28.25 89.6667 28.2778 90.5 28.8333L120 47.6667C120.778 48.1667 121.167 48.8611 121.167 49.75C121.167 50.6389 120.778 51.3333 120 51.8333L90.5 70.6667ZM91.6667 64L114.083 49.75L91.6667 35.5V64Z"
      fill="#F8B332"
    />
  </svg>
);

export default PlayButton;
